import { useState } from "react";

const useTextField = (
  initialValue = "",
  initialError = false,
  initialHelperText = "",
) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(initialError);
  const [helperText, setHelperText] = useState(initialHelperText);

  const resetError = () => {
    setError(false);
    setHelperText("");
  };

  const alertError = (errorText) => {
    setError(true);
    setHelperText(errorText);
  };

  const resetText = () => {
    setValue("");
    setHelperText("");
  };

  return {
    value,
    setValue,
    error,
    setError,
    helperText,
    setHelperText,
    resetError,
    alertError,
    resetText,
  };
};

export default useTextField;